export const EMAIL_CONFIG_CHANGED_EVENT = 'nbh:email-config-changed';
